import { render } from "./print-creditor-receipt.vue?vue&type=template&id=1c13e736"
import script from "./print-creditor-receipt.vue?vue&type=script&lang=js"
export * from "./print-creditor-receipt.vue?vue&type=script&lang=js"

import "./print-creditor-receipt.vue?vue&type=style&index=0&id=1c13e736&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__